class BaseComponent
{


    constructor()
    {
        this.app = PIXI.app;
        this.entitySystem = this.app.controller.eSys;
        this.type = this.constructor.name;
        this.id = this.app.model.getUID();
    }


    getId()
    {
        return this.id;
    }


    getEntity()
    {
        return this.entity;
    }


    init()
    {

    }


    delayedQueueForRemoval(delay)
    {
        TweenMax.to(this.getEntity(), 0, {delay:delay, queueForRemoval:true});
    }


    destroy()
    {
        TweenMax.killTweensOf(this);
    }


}


export default BaseComponent;